import jsonFetch from "common/services/fetch/jsonFetch"
import { FEEDBACK_COMMENT_FIELD } from "common/consts/helpCenter"
// TODO: Allow headers on api and then remove disableTracking

export function langFetch(apiUrl, url, langInfo) {
  const lngQueryPar = url.includes("?") ? `&lang=${langInfo.iso}` : `?lang=${langInfo.iso}`
  // lang also in url because of caching
  return jsonFetch(`${apiUrl}${url}${lngQueryPar}`, {
    headers: {
      "Accept-Language": langInfo.iso,
    },
    disableTracking: true,
  })
}

export function getArticle(apiUrl, id, langInfo) {
  // lang also in url because of caching
  return jsonFetch(`${apiUrl}/articles/${id}?lang=${langInfo.iso}`, {
    headers: {
      "Accept-Language": langInfo.iso,
    },
    disableTracking: true,
  })
}

export function vote(apiUrl, id, value) {
  return jsonFetch(`${apiUrl}/articles/${id}/vote`, {
    body: { vote: value },
    disableTracking: true,
  })
}

export function comment(apiUrl, id, value, field) {
  const body = { comment: value }

  if (field === FEEDBACK_COMMENT_FIELD.CUSTOM) {
    body.type = "other"
  }

  return jsonFetch(`${apiUrl}/articles/${id}/comment`, {
    body,
    disableTracking: true,
  })
}
